export default "__VITE_ASSET__B7Jo_MS3__"